interface SliderProps {
  label: string
  value: number
  onChange: (value: number) => void
  min: number
  max: number
  step?: number
  formatValue?: (value: number) => string
  accent?: 'emerald' | 'teal' | 'cyan' | 'amber'
}

const accentClass: Record<string, string> = {
  emerald: 'accent-emerald-500',
  teal: 'accent-teal-500',
  cyan: 'accent-cyan-500',
  amber: 'accent-amber-500',
}

const accentText: Record<string, string> = {
  emerald: 'text-emerald-400',
  teal: 'text-teal-400',
  cyan: 'text-cyan-400',
  amber: 'text-amber-400',
}

function Slider({ label, value, onChange, min, max, step = 1, formatValue, accent = 'emerald' }: SliderProps) {
  return (
    <label className="block">
      <span className="mb-1.5 flex items-center justify-between text-sm font-medium text-slate-300">
        <span>{label}</span>
        <span className={`font-mono text-sm ${accentText[accent]}`}>{formatValue ? formatValue(value) : value}</span>
      </span>
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        className={`h-2 w-full cursor-pointer rounded-lg bg-slate-800 ${accentClass[accent]}`}
      />
    </label>
  )
}

export default Slider
